import {
  ArrowIcon,
  IconButton,
  LabeledCheckbox,
  Text,
} from "@commonsku/styles";
import React, { useState } from "react";
import { GoBackButton } from "./Questionnaire";

interface FeeApprovalPageProps {
  shopType: string;
  handleCustomRouting: (newRoute: string, selectedShopType?: string) => void;
}

const FeeApprovalPage = ({
  shopType,
  handleCustomRouting,
}: FeeApprovalPageProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  // need an endpoint to set fee approval on the DB after clicking the accept and continue
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "60%",
        margin: "auto",
        marginTop: 64,
        marginBottom: 64,
      }}
    >
      <div style={{ textAlign: "left" }}>
        <Text
          as="h1"
          style={{ fontWeight: 600, fontSize: 32, marginBottom: 32 }}
        >
          Fee Approval
        </Text>
        <Text
          as="p"
          style={{ marginBottom: 24, fontSize: 18, fontWeight: 400 }}
        >
          A 1% fee will be applied to all checkouts imported into commonsku
          through Shopify Shops. Please note that this is the only charge
          applied.
        </Text>
        <LabeledCheckbox
          label="I acknowledge and approve this fee."
          labelStyle={{ fontWeight: 400, fontSize: 18 }}
          checked={isChecked}
          onClick={() => setIsChecked(!isChecked)}
        />
        <div style={{ marginTop: 16 }}>
          <IconButton
            size="large"
            Icon={ArrowIcon}
            iconPosition="right"
            onClick={() => handleCustomRouting("createShopPage", shopType)}
            id="shopCreation-selectedShopPage-createShop.btn"
            style={{ marginBottom: 24 }}
            disabled={!isChecked}
          >
            Accept and continue
          </IconButton>
          <GoBackButton
            variant="text"
            size="small"
            style={{ display: "block" }}
            onClick={() => handleCustomRouting("initialize")}
            id={`shopCreation-questionnaire-goBack.btn`}
          >
            Take Me Back to Shop Selection
          </GoBackButton>
        </div>
      </div>
    </div>
  );
};

export default FeeApprovalPage;
